export const classes = [
	{
        id: "C138038",
        class: "Year 1",
        section: "Jupiter",
        noOfStudents: 30,
        noOfSubjects: 0o3,
        status: "Active",
        key:1
      },
      {
        id: "C138037",
        class: "Year 1",
        section: "Mars",
        noOfStudents: 25,
        noOfSubjects: 0o3,
        status: "Active",
        key:2
      },
      {
        id: "C138036",
        class: "Year 2",
        section: "Jupiter",
        noOfStudents: 40,
        noOfSubjects: 0o3,
        status: "Active",
        key:3
      },
      {
        id: "C138035",
        class: "Year 2",
        section: "Mars",
        noOfStudents: 35,
        noOfSubjects: 0o3,
        status: "Active",
        key:4
      },
      {
        id: "C138034",
        class: "Year 2",
        section: "Saturn",
        noOfStudents: 25,
        noOfSubjects: 0o3,
        status: "Inactive",
        key:5
      },
      {
        id: "C138033",
        class: "Year 3",
        section: "Jupiter",
        noOfStudents: 30,
        noOfSubjects: 0o3,
        status: "Active",
        key:6
      },
      {
        id: "C138032",
        class: "Year 3",
        section: "Mars",
        noOfStudents: 25,
        noOfSubjects: 0o5,
        status: "Active",
        key:7
      },
      {
        id: "C138031",
        class: "Year 4",
        section: "Jupiter",
        noOfStudents: 20,
        noOfSubjects: 0o5,
        status: "Active",
        key:8
      },
      {
        id: "C138030",
        class: "Year 4",
        section: "Mars",
        noOfStudents: 30,
        noOfSubjects: 0o5,
        status: "Inactive",
        key:9
      },
      {
        id: "C138029",
        class: "Year 5",
        section: "Jupiter",
        noOfStudents: 35,
        noOfSubjects: 0o5,
        status: "Active",
        key:10
      }
];
